<!--
 * @Author: your name
 * @Date: 2021-10-29 15:42:35
 * @LastEditTime: 2021-11-15 18:37:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \adminCRM\src\components\customerCheck\customerLabel.vue
-->
<template>
<div id="customerCarInfo" class="container">
   <el-form :model="addForm" ref="addForm" label-width="150px" class="demo-addruleForm">
          <el-form-item label="标签分类" prop="labeltype">
             <el-select v-model="addForm.labeltype" @change="exportType" placeholder="请选择">
              <el-option
                v-for="item in customer"
                :key="item.groupName"
                :label="item.groupName"
                :value="item.groupId">
                {{ item.groupName }}
                <!-- <div class="typebox">
                  <div class="typeGroup">{{ item.groupName }}</div>
                  <div class="typeTag"><small v-for="(tag,ind) in item.corpTags" :key="ind">{{ tag.tagName }}</small></div>
                </div> -->
              </el-option>
            </el-select>
            <el-button @click="openAddDialog">新增标签</el-button>
          </el-form-item>
          <el-form-item label="标签名称" prop="tagName">
            <el-tag
                :key="tag.tagName"
                v-for="tag in exportTags"
                closable
                :disable-transitions="false"
                @close="handleExpClose(tag)">
                {{tag.tagName}}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="EXPVisible"
                v-model="inputExp"
                ref="expTagInput"
                size="small"
                @keyup.enter.native="exportConfirm"
                @blur="exportConfirm"
              >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showExportInput">+ 添加标签名称</el-button>
            </el-form-item>
            <el-form-item label="批量导入用户：" prop="">
            <el-upload
              class="upload-demo" ref="excelUpload"
              :limit='1'
              :file-list="fileList"
              action=""
              accept=".xls,.xlsx,.csv"
              name="goodsFile"
              :auto-upload="false"
              :with-credentials="true"
              :on-remove="handleRemove"
              :on-error="handleError"
              :on-exceed="fullUpload"
              :on-change="handleChange"
              :on-success="handleSuccess">
              <el-button slot="trigger" size="small" type="primary">导入Excel</el-button>
            </el-upload>
            {{this.tips}}
          </el-form-item>
           <!-- <el-form-item v-if="showPro" prop="">
            <el-progress :text-inside="true" :stroke-width="12" :percentage="percentage" status="success"></el-progress>
          </el-form-item> -->
        </el-form>
        <div style="margin-left:130px;">
            <el-button v-if="successCount>0" type="success" icon="el-icon-check" plain>已成功导入{{successCount}}条数据</el-button>
            <el-button v-if="faileCount>0" type="danger" icon="el-icon-close" plain>用户unionId失败{{faileCount}}条</el-button>
           <el-table
            :data="tableData"
            style="width: 88%;">
            <el-table-column
              prop="nickName"
              label="用户昵称">
            </el-table-column>
            <el-table-column
              prop="mobile"
              label="用户手机号">
            </el-table-column>
            <el-table-column
              prop="unionId"
              label="unionId">
            </el-table-column>
            <el-table-column
              fixed
              prop="date"
              label="注册时间"
              width="150">
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="deleteRow(scope.$index, tableData)"
                  type="text"
                  size="small">
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="felxEnd container">
          <el-button @click="resetALL('addForm')">取消</el-button>
          <el-button type="primary" @click="exportUnionSubmit('addForm')">保存</el-button>
        </div>
    <el-dialog title="添加企业标签" :visible.sync="labelVisible" width="1200px" :before-close="resetAdd">
     <el-form :model="addruleForm" ref="addruleForm" label-width="100px" class="demo-addruleForm">
          <el-form-item label="标签分类" prop="labeltype">
             <el-select v-model="addruleForm.labeltype" @change="changeType" placeholder="请选择">
              <el-button class="button-new-tag" size="small" @click="typeInput">+ 添加标签分类</el-button>
              <div class="container" v-if="showAddInput">
                <el-input placeholder="请输入内容" style="width:210px;" v-model="labelname" clearable></el-input>
                <el-button class="button-new-tag" size="small" @click="typeSubmitInput">确认</el-button>
              </div>
              <el-option
                v-for="item in customerCopy"
                :key="item.groupName"
                :label="item.groupName"
                :value="item.groupId">
                <div class="typebox">
                  <div class="typeGroup">{{ item.groupName }}</div>
                  <div class="typeTag"><small v-for="(tag,ind) in item.corpTags" :key="ind">{{ tag.tagName }}</small></div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签名称" prop="tagName">
            <el-tag
                :key="tag"
                v-for="tag in dynamicTags"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)">
                {{tag.tagName}}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加标签名称</el-button>
          </el-form-item>
          <el-form-item class="flexEnd">
            <el-button @click="resetAdd('addruleForm')">取消</el-button>
            <el-button type="primary" @click="submitAddForm('addruleForm')">保存</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
</div>
</template>

<script>
import http from '@/api/label';
export default {
  name: 'labelManage',
  props: ['mobile', 'update'],
  data () {
    return {
      customer: [],
      customerCopy: [],
      closeKuHandle: false,
      labelVisible: false,
      labelname: '',
      addruleForm: {
        labeltype: '',
        tagName: ''
      },
      addForm: {
        labeltype: '',
        tagName: ''
      },
      dynamicTags: [],
      exportTags: [],
      inputVisible: false,
      EXPVisible: false,
      inputExp: '',
      inputValue: '',
      labelTreeDialog: false,
      showCheckedKeys: [],
      showAddInput: false,
      fileList: [],
      files: '', // 文件流
      tableData: [],
      tips: '',
      successCount: 0,
      faileCount: 0,
      isTrue: false
      // percentage: 0,
      // showPro: false
    };
  },
  watch: {
    'update' () {
      // 先格式化data
    }
  },
  created () {
    this.getLabelList();
  },
  methods: {
    getLabelList () {
      http.userAllList().then((res) => {
        if (res.success) {
          this.customer = res.data;
        }
      });
    },
    openAddDialog () {
      this.labelVisible = true;
      this.showAddInput = false;
      this.inputVisible = false;
      this.addruleForm.labeltype = '';
      this.dynamicTags = [];
      this.customerCopy = this.customer;
    },
    reomveZiLabel (tagId) {
      this.customer.map(item => {
        item.corpTags.map(Tags => {
          if (tagId === Tags.tagId) {
            item.corpTags.splice(item.corpTags.indexOf(Tags), 1);
          }
        });
      });
    },
    saveLable () {
      this.customer = JSON.parse(JSON.stringify(this.customer).replace(/corpTags/g, 'tag').replace(/tagId/g, 'id').replace(/tagName/g, 'name'));
      http.addLabelSave(this.customer).then((res) => {
        if (res.success) {
          this.showAddInput = false;
          this.getLabelList();
        }
      });
      this.closeKuHandle = false;
      this.getLabelList();
    },
    closeLable () {
      this.closeKuHandle = false;
      this.getLabelList();
    },
    addSelectLabel () {
      this.labelVisible = true;
      this.customerCopy = this.customer;
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.customerCopy.map(item => {
        if (this.addruleForm.labeltype === item.groupId) {
          item.corpTags = this.dynamicTags;
        }
      });
    },
    showInput () {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm () {
      if (this.inputValue == '') {
        this.inputVisible = false;
        return this.$message.warning('标签名称不可为空!');
      }
      if (!this.addruleForm.labeltype) {
        this.inputValue = '';
        return this.$message.warning('请先选择或新增标签分类!');
      }
      if (this.inputValue.trim()) {
        this.dynamicTags.map(s => {
          if (s.tagName == this.inputValue) {
            this.inputValue = '';
            return this.$message.warning('同分类标签名称不能相同!');
          }
        });
        if (this.inputValue) {
          this.dynamicTags.push({
            tagId: '',
            tagName: this.inputValue
          });
          this.customerCopy.map(item => {
            if (this.addruleForm.labeltype === item.groupId) {
              item.corpTags = this.dynamicTags;
            }
          });
        }
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    changeType () {
      console.log('addruleForm', this.addruleForm);
      this.customerCopy.map(item => {
        if (this.addruleForm.labeltype === item.groupId) {
          this.dynamicTags = item.corpTags;
        }
      });
      this.inputVisible = false;
      console.log('this.dynamicTags', this.dynamicTags);
    },
    showExportInput () {
      this.EXPVisible = true;
      this.$nextTick(_ => {
        this.$refs.expTagInput.$refs.input.focus();
      });
    },
    exportType () {
      console.log('addForm', this.addForm);
      this.customer.map(item => {
        if (this.addForm.labeltype === item.groupId) {
          this.exportTags = item.corpTags;
        }
      });
      this.EXPVisible = false;
      console.log('this.exportTags', this.exportTags);
    },
    handleExpClose (tag) {
      this.exportTags.splice(this.exportTags.indexOf(tag), 1);
      // this.customer.map(item => {
      //   if (this.addForm.labeltype === item.groupId) {
      //     item.corpTags = this.exportTags;
      //   }
      // });
    },
    exportConfirm () {
      if (this.inputExp == '') {
        this.EXPVisible = false;
        return this.$message.warning('标签名称不可为空!');
      }
      if (!this.addForm.labeltype) {
        this.inputExp = '';
        return this.$message.warning('请先选择或新增标签分类!');
      }
      console.log('this.inputExp', this.inputExp);
      if (this.inputExp.trim()) {
        this.exportTags.push({
          tagId: '',
          tagName: this.inputExp
        });
      }
      this.EXPVisible = false;
      this.inputExp = '';
    },
    typeInput () {
      console.log('新分类', this.labelname);
      this.labelname = '';
      this.showAddInput = true;
    },
    typeSubmitInput () {
      if (this.labelname) {
        this.customerCopy.map(item => {
          if (this.labelname === item.groupName) {
            this.labelname = '';
            return this.$message.warning('分类名称不能相同!');
          }
        });
        console.log('this.labelname', this.labelname);
        if (this.labelname) {
          this.customerCopy.push({
            groupId: this.labelname,
            groupName: this.labelname,
            corpTags: []
          });
          this.labelname = '';
          this.showAddInput = false;
        }
      } else {
        return this.$message.warning('请输入分类名称!');
      }
      // console.log('this.customerCopy', this.customerCopy);
    },
    submitAddForm () {
      if (!this.addruleForm.labeltype) {
        return this.$message.warning('请先选择或新增标签分类!');
      }
      if (this.dynamicTags.length === 0) {
        return this.$message.warning('请添加标签名称!');
      }
      this.customerCopy = JSON.parse(JSON.stringify(this.customerCopy).replace(/corpTags/g, 'tag').replace(/tagId/g, 'id').replace(/tagName/g, 'name'));
      http.addLabelSave(this.customerCopy).then((res) => {
        if (res.success) {
          this.$message.success('添加成功!');
          this.labelVisible = false;
          this.getLabelList();
        }
      });
    },
    resetAdd () {
      this.labelVisible = false;
      this.getLabelList();
    },
    handleChange (file, fileList) {
      console.log(file);
      console.log(fileList);
      const formData = new FormData();
      formData.append('file', file.raw);
      this.tips = '文件上传中...';
      http.exportUnion(formData).then((res) => {
        console.log('res', res);
        if (res.success) {
          this.tableData = res.data.userTagExcelVOList;
          this.successCount = res.data.successCount;
          this.faileCount = res.data.faileCount;
          this.$message.success('上传成功!');
          this.tips = '';
        }
      });
    },
    beforeAvatarUpload (file) {
      console.log(file.name);
    },
    handleError (file) {
      this.$message.error(file.name + '上传失败!');
    },
    handleSuccess (res, file, fileList) {
      console.log('----上传成功');
      if (res.success) {
        this.$message.success('上传成功!');
      } else {
        this.$confirm(res.message, '提示', {
          confirmButtonText: '确定',
          center: true,
          type: 'warning'
        });
      }
    },
    handleRemove (file, fileList) {
      console.log('remove');
    },
    // 上传超出限制
    fullUpload () {
      this.$confirm('超出上传个数限制，请删除当前文件后再上传', '提示', {
        confirmButtonText: '确定',
        center: true,
        type: 'warning'
      });
    },
    exportUnionSubmit () {
      if (!this.addForm.labeltype) {
        return this.$message.warning('请先选择或新增标签分类!');
      }
      // let ids = [];
      if (this.exportTags.length <= 0) {
        return this.$message.warning('请添加标签名称!');
      } else if (this.tableData.length <= 0) {
        return this.$message.warning('请上传excel文件!');
      }
      // this.exportTags.map(item => {
      //   ids.push(item.tagId);
      // });
      const params = {
        tag: this.exportTags,
        groupId: this.addForm.labeltype,
        userTagExcelVOS: this.tableData
      };
      // console.log('ids', params);
      http.exportUnionSubmit(params).then((res) => {
        if (res.success) {
          this.$message.success('保存成功!');
          this.resetALL();
          this.getLabelList();
        }
      });
    },
    resetALL () {
      this.addForm.labeltype = '';
      this.exportTags = [];
      this.tableData = [];
      this.fileList = [];
      this.successCount = 0;
      this.faileCount = 0;
    },
    deleteRow (index) {
      this.tableData.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
#customerCarInfo{min-width: 800px;min-height:900px; margin-left: 60px;}
.opretaBtn{position:fixed;bottom:0;right:0;padding-right:60px;padding-bottom:15px;display:flex;justify-content: flex-end;margin-bottom:15px;}
.container{padding: 10px;}
.el-tag{margin-right:8px; margin-bottom:5px;}
.tagTitle{margin-bottom:10px; margin-top:10px;}
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .addType{
    margin-top:15px;
  }
  .flexEnd{
    display: flex;
    justify-content: flex-end;
    margin-right:20px;
  }
  .typebox{
    display: flex;
    flex-direction: row;
    min-width: 1000px;
    max-width:1000px;
    border-bottom:1px solid #eeeeee;
  }
  .typeGroup{
    min-width:150px;
    margin-right:10px;
  }
  .typeTag{
    min-width:850px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    overflow-x: scroll;
   small{
      margin-left:8px;
   }
  }
  .typeTag::-webkit-scrollbar {
    display: none;
  }
  .felxEnd{
    display:flex;
    justify-content: flex-end;
  }
</style>



// WEBPACK FOOTER //
// src/components/customerCheck/userLabelCheck.vue